export default "__VITE_ASSET__Cy8oFV8E__"